import { getUser } from "./auth";
export default {
	isOnline: true,
	isLoading: false,
	credentials: false,
	user: getUser() ? getUser() : false,
	messages: [],
	entryCache: [],
	entries: [],
	temp: {
		refueling: {
			refuelling_amount: "",
			odometer_reading: "",
			price: "",
			refueled_at: "",
			refuelling_station_location: "",
			electricity_amount: "",
			notes: ""
		}
	},
	currencySymbols: {
		EUR: "€",
		GBP: "£",
		ISK: "Íkr",
		CHF: "Fr",
		DKK: "kr",
		SEK: "kr",
		PLN: "zł",
		CZK: "Kč"
	},
	loadCurrencySymbol: function(ISOCode) {
		if (this.currencySymbols.hasOwnProperty(ISOCode)) {
			return this.currencySymbols[ISOCode];
		}
		return "€";
	}
};



// WEBPACK FOOTER //
// ./src/utils/store.js